import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleEnum } from '@app/shared/enum/role.enum';
import { IpsComponent } from './ips.component';

const defaultRouteGuards = [RoleEnum.IPS.toString()];
const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: IpsComponent,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'pedidos',
        loadChildren: async () => (await import('./order/order.module')).OrderModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'triagem',
        loadChildren: async () => (await import('./screening/screening.module')).ScreeningModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'precificacao',
        loadChildren: async () => (await import('./pricing/pricing.module')).PricingModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'relatorio',
        loadChildren: async () => (await import('./reports/reports.module')).ReportsModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'reaberturas',
        loadChildren: async () => (await import('./reopenings/reopenings.module')).ReopeningsModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'acessos',
        loadChildren: async () =>
          (await import('../core/access-control/access-control.module')).AccessControlModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'erros',
        loadChildren: async () =>
          (await import('./errors-manager/errors-manager.module')).ErrorsManagerModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'logs',
        loadChildren: async () => (await import('./logs/ips-logs.module')).LogsIpsModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'laudo-complementar',
        loadChildren: async () =>
          (await import('./separate-report/separate-report.module')).SeparateReportModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IpsRoutingModule {}
